// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"fd139db6","110":"efd938c3","368":"d8da4775","406":"dff09ba0","453":"3a300bcc","577":"4cb1215f","723":"269fed5c","744":"f6c9c13d"}[chunkId] + ".chunk.js";
};